export const headerName = {
    add: "Добавить документ",
    edit: "Редактировать документ",
};
export const identificationDocumentsInputs = {
    dtname: {
        key: "dtname",
        label: "Наименование документа",
        type: "text",
        required: true,
    },
}
export const getIdentificationDocumentsInputs = ()=>identificationDocumentsInputs